import React, { useEffect, useState } from 'react';
import NavButton from '../../components/ul/NavButton';
import Calling from '../../api/Calling';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ selectState }) => {
    const [deleteReq, setDeleteReq] = useState(0);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const response = await Calling.getuserDeleteReq();
            if (response?.status) {
                setDeleteReq(response.userReq);
            }
        } catch (error) {
            console.error('Error fetching delete requests:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDeleteReq = () => {
        navigate('/manage/user/all/delete/req');
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="text-main-font w-full p-4 mt-3">
            <div className="flex justify-between items-center">
                {/* Mobile menu button - only visible on small screens */}
                <button
                    className="lg:hidden focus:outline-none"
                    onClick={toggleMobileMenu}
                    aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                >
                    {mobileMenuOpen ? (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* X icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </div>
                    ) : (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* Menu icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </div>
                    )}
                </button>

                {/* Desktop navigation - hidden on small screens */}
                <ul className="hidden lg:flex space-x-4">
                    <li>
                        <NavButton to="/manage/user/all/data" btnName="User" selectState={selectState === "user"} />
                    </li>
                    <li>
                        <NavButton to="/manage/user/login/all/data" btnName="Login" selectState={selectState === "login"} />
                    </li>
                    <li>
                        <NavButton to="/manage/user/comeback" btnName="Come Back" selectState={selectState === "comeback"} />
                    </li>
                </ul>

                {/* Delete Request button - visible on all screen sizes */}
                <div className='flex'>
                    <button
                        onClick={handleDeleteReq}
                        className="float-right bg-main-delete px-3 rounded-lg transition py-2 text-main-white border border-main-delete hover:bg-main-delete/80 text-sm"
                    >
                        {`Request (${deleteReq})`}
                    </button>
                </div>
            </div>

            {/* Mobile navigation - only shown when menu is open */}
            {mobileMenuOpen && (
                <div className="lg:hidden mt-4 bg-white shadow rounded-lg p-4">
                    <ul className="flex flex-col space-y-2">
                        <li>
                            <NavButton to="/manage/user/all/data" btnName="User" selectState={selectState === "user"} />
                        </li>
                        <li>
                            <NavButton to="/manage/user/login/all/data" btnName="Login" selectState={selectState === "login"} />
                        </li>
                        <li>
                            <NavButton to="/manage/user/comeback" btnName="Come Back" selectState={selectState === "comeback"} />
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default Navbar;